/**
 * Auto-generated version information for Compounds.dev Web.
 * DO NOT EDIT THIS FILE MANUALLY - it's generated by scripts/generate_version.sh
 *
 * This file is used for:
 * - Displaying version in UI footer
 * - Logging and error reporting
 * - Build tracking
 */

export const VERSION = '0.3.0+316fb0e'
export const GIT_COMMIT = '316fb0ed0b6bb7e84ce7af67d4f9952512405b36'
export const GIT_COMMIT_SHORT = '316fb0e'
export const GIT_BRANCH = 'master'
export const GIT_TAG = ''
export const BUILD_DATE = '2026-10-21T15:51:42Z'
export const BUILD_TIMESTAMP = 1792597902
export const IS_DIRTY = false

export interface VersionInfo {
  version: string
  gitCommit: string
  gitCommitShort: string
  gitBranch: string
  gitTag: string
  buildDate: string
  buildTimestamp: number
  isDirty: boolean
}

export function getVersionInfo(): VersionInfo {
  return {
    version: VERSION,
    gitCommit: GIT_COMMIT,
    gitCommitShort: GIT_COMMIT_SHORT,
    gitBranch: GIT_BRANCH,
    gitTag: GIT_TAG,
    buildDate: BUILD_DATE,
    buildTimestamp: BUILD_TIMESTAMP,
    isDirty: IS_DIRTY
  }
}

export function getVersionString(): string {
  return VERSION
}
